import { Card, Table, Typography } from 'antd';

const { Title } = Typography;

const columns = [
  {
    title: 'Account Name',
    dataIndex: 'account_name',
    width: '16%',
    render: (text) => <Title level={5}>{text}</Title>,
  },
  {
    title: 'NAV',
    dataIndex: 'nav',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Final Return',
    dataIndex: 'final_return',
    align: 'right',
    width: '12%',
  },
  {
    title: 'MDD',
    dataIndex: 'mdd',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Sharpe Ratio',
    dataIndex: 'sharpe_ratio',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Ann. Return',
    dataIndex: 'ann_return',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Ann. Volatility',
    dataIndex: 'ann_volatility',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Skew',
    dataIndex: 'skew',
    align: 'right',
    width: '12%',
  },
  {
    title: 'Sortino',
    dataIndex: 'sortino',
    align: 'right',
    width: '12%',
  },
];

function StatisticsTable({ data }) {
  return (
    <>
      <div className='tabled'>
        <Card
          bordered={false}
          className='criclebox tablespace mb-24'
          title='Statistics'
        >
          <div className='table-responsive'>
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              className='ant-border-space'
            />
          </div>
        </Card>
      </div>
    </>
  );
}

export default StatisticsTable;
